import { Component, computed, input } from '@angular/core';
import { VerifizierungsBadgeDto } from '../../../core/models/verifizierung-badge.model';

/**
 * Kategorie-getriebenes Verifizierungs-Badge (Spec: Gewerk-Taxonomie & Verifizierung,
 * § 4). Rendert die Badge-Stufe („Meisterbetrieb" / „Gewerbe verifiziert") inkl. des
 * optionalen „· versichert"-Zusatzes — ausschließlich aus dem Server-Label, nie
 * pauschal „Meister". `variant="pill"` für Overlays (z. B. Such-Karte), `variant="row"`
 * für Trust-Listen auf Profil/Drawer.
 */
@Component({
  selector: 'app-verifizierung-badge',
  standalone: true,
  templateUrl: './verifizierung-badge.component.html',
  styleUrl: './verifizierung-badge.component.scss',
})
export class VerifizierungsBadgeComponent {
  readonly badge = input.required<VerifizierungsBadgeDto>();
  readonly variant = input<'pill' | 'row'>('pill');

  protected readonly istMeister = computed(() => this.badge().stufe === 'Meisterbetrieb');
  protected readonly title = computed(() =>
    this.istMeister()
      ? 'Meisterbrief, Gewerbe und Identität geprüft'
      : 'Gewerbe und Identität geprüft',
  );
  /** Trust-Sub-Zeile (nur Variante „row"). Behauptet Versicherung nur, wenn nachgewiesen. */
  protected readonly sub = computed(() => {
    const base = this.istMeister()
      ? 'Meisterbrief & Gewerbe geprüft'
      : 'Gewerbe & Identität geprüft';
    return this.badge().versichert ? `${base} · Betriebshaftpflicht nachgewiesen` : base;
  });
}
